import { useTranslation } from 'react-i18next';
import ApiClient from '../../../Common/apiClient'
import * as APIURL from '../../../Common/APIurls'
const fetchApigeeToken = async (APIGEE_URL) => { 
   const response = await ApiClient.get(APIGEE_URL)

   if(response?.data?.access_token) {
    return (response.data.access_token)
   } 
   return null
}

export default fetchApigeeToken
